import React from 'react';
import load from '@loadable/component';

import { BaseScreen } from '@screens/BaseScreen';

type Screen = React.ComponentType & { getLayout: () => JSX.Element };

type DefaultImportedComponent = {
  default: Screen;
};

const importScreen = (supplier) =>
  load(supplier, {
    resolveComponent: (component: DefaultImportedComponent, props: any) => {
      const Component = component.default;

      const getLayout =
        Component.getLayout ||
        ((children) => <BaseScreen>{children}</BaseScreen>);

      return () => getLayout(<Component {...props} />);
    },
  });

export { importScreen };
